import { CareTeamProviderType } from '~/lib/constants/patients.constants';

export const getInquiryById = (
  inquiryId: string,
  inquiries: InquiryViewsListItemResponse[],
) => {
  return inquiries?.find((inquiry) => inquiry.inquiryId === inquiryId);
};

/**
 *  Only add assignments to inquiry.assignedPSRs where provider type = PSR
 */
export const getAssignmentsForRoleWithAssignmentIds = (
  assignmentsRequested: Omit<InquiryListItemAssignment, 'assignmentId'>[],
  assignmentsResponse: UpdateInquiryAssignmentsResponse,
  providerType: CareTeamProviderType,
): InquiryListItemAssignment[] => {
  return assignmentsRequested
    .filter(
      (assignmentRequested) =>
        assignmentRequested.providerType?.toLowerCase() === providerType,
    )
    .map((assignmentRequested) => ({
      assignmentId: assignmentsResponse.assignments.find(
        (assignmentResponse) =>
          assignmentResponse.userId === assignmentRequested.externalId,
      )?.id,
      externalId: assignmentRequested.externalId,
      firstName: assignmentRequested.firstName,
      lastName: assignmentRequested.lastName,
      providerType: assignmentRequested.providerType,
    }));
};

export const addAssignment = (
  existingAssignments: InquiryListItemAssignment[],
  newAssignment: InquiryListItemAssignment,
  assignmentId: string,
) => {
  return [...(existingAssignments ?? []), { ...newAssignment, assignmentId }];
};

export const removeAssignment = (
  assignmentId: string,
  assignments: InquiryListItemAssignment[],
) => {
  return (assignments ?? []).filter((a) => a.assignmentId !== assignmentId);
};
